export const SEO = {
  head: {
    title: 'Accessibility Statement | Gousto | Recipe Boxes',
    meta: [
      {
        name: 'description',
        content:
          "Read Gousto's accessibility statement for our website and Gousto app on our legal pages.",
      },
    ],
  },
}
